
import { Loader2 } from 'lucide-react';

export function LoadingSpinner() {
  return (
    <div className="flex flex-col items-center justify-center space-y-4 my-12">
      <Loader2 className="h-12 w-12 animate-spin text-primary" />
      <p className="text-muted-foreground text-lg">Analyzing your website...</p>
      <p className="text-sm text-muted-foreground">This may take a moment.</p>
    </div>
  );
}
